import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { formatCurrency, parseCurrency } from '../InputText';
import { DisplayInput } from '../DisplayInput';

export const DisplayInputNumber = ({ defaultValue, onChange, inputRef, ...otherProps }) => {
    const [value, setValue] = useState(defaultValue);
    const ref = inputRef || useRef();

    const interceptOnChange = evt => {
        const formattedValue = (evt.target.value || '').replace(/[^\d,.]/g, '');
        setValue(formattedValue);
        ref.current.value = formattedValue;
        onChange(evt);
    };

    return (
        <DisplayInput inputRef={ref} value={value} onChange={interceptOnChange} {...otherProps} />
    );
};

DisplayInputNumber.propTypes = {
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    inputRef: PropTypes.shape({}),
};

DisplayInputNumber.defaultProps = {
    defaultValue: '',
    onChange: () => null,
    inputRef: null,
};

export const DisplayInputInteger = ({ defaultValue, onChange, inputRef, ...otherProps }) => {
    const [value, setValue] = useState(defaultValue);
    const ref = inputRef || useRef();

    const interceptOnChange = evt => {
        const formattedValue = (evt.target.value || '').replace(/\D/g, '');
        setValue(formattedValue);
        ref.current.value = formattedValue;
        onChange(evt);
    };

    return (
        <DisplayInput inputRef={ref} value={value} onChange={interceptOnChange} {...otherProps} />
    );
};

DisplayInputInteger.propTypes = {
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    inputRef: PropTypes.shape({}),
};

DisplayInputInteger.defaultProps = {
    defaultValue: '',
    onChange: () => null,
    inputRef: null,
};

export const DisplayInputCurrency = ({
    defaultValue,
    onChange,
    inputRef,
    currency,
    cents,
    thousands,
    ...otherProps
}) => {
    const [value, setValue] = useState(
        formatCurrency(defaultValue, { currency, thousands, cents }),
    );
    const ref = inputRef || useRef();

    const interceptOnChange = evt => {
        const newValue = String(evt.target.value || '').replace(/[^\d/]/g, '');
        let formattedValue;
        if (!Number.isNaN(newValue)) {
            formattedValue = Number(newValue) / 100;
        }
        formattedValue = formatCurrency(formattedValue, { currency, thousands, cents });
        setValue(formattedValue);
        ref.current.value = formattedValue;
        onChange(evt, { parsedValue: parseCurrency(formattedValue) });
    };

    return (
        <DisplayInput inputRef={ref} value={value} onChange={interceptOnChange} {...otherProps} />
    );
};

DisplayInputCurrency.propTypes = {
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    inputRef: PropTypes.shape({}),
    currency: PropTypes.string,
    thousands: PropTypes.string,
    cents: PropTypes.string,
};

DisplayInputCurrency.defaultProps = {
    defaultValue: '',
    onChange: () => null,
    inputRef: null,
    currency: 'R$ ',
    thousands: '.',
    cents: ',',
};
